var postCommon = {};

postCommon.MIMETYPES = {
  a : 'application/octet-stream',
  ai : 'application/postscript',
  aif : 'audio/x-aiff',
  aifc : 'audio/x-aiff',
  aiff : 'audio/x-aiff',
  au : 'audio/basic',
  avi : 'video/x-msvideo',
  bat : 'text/plain',
  bin : 'application/octet-stream',
  bmp : 'image/x-ms-bmp',
  c : 'text/plain',
  cdf : 'application/x-cdf',
  csh : 'application/x-csh',
  css : 'text/css',
  dll : 'application/octet-stream',
  doc : 'application/msword',
  dot : 'application/msword',
  dvi : 'application/x-dvi',
  eml : 'message/rfc822',
  eps : 'application/postscript',
  etx : 'text/x-setext',
  exe : 'application/octet-stream',
  flac : 'audio/flac',
  gif : 'image/gif',
  gtar : 'application/x-gtar',
  gz : 'application/gzip',
  h : 'text/plain',
  hdf : 'application/x-hdf',
  htm : 'text/html',
  html : 'text/html',
  jpe : 'image/jpeg',
  jpeg : 'image/jpeg',
  jpg : 'image/jpeg',
  js : 'application/x-javascript',
  ksh : 'text/plain',
  latex : 'application/x-latex',
  m1v : 'video/mpeg',
  m4a: 'audio/x-m4a',
  m4v : 'video/x-m4v',
  man : 'application/x-troff-man',
  me : 'application/x-troff-me',
  mht : 'message/rfc822',
  mhtml : 'message/rfc822',
  mif : 'application/x-mif',
  mov : 'video/quicktime',
  movie : 'video/x-sgi-movie',
  mp2 : 'audio/mpeg',
  mp3 : 'audio/mpeg',
  mp4 : 'video/mp4',
  mpa : 'video/mpeg',
  mpe : 'video/mpeg',
  mpeg : 'video/mpeg',
  mpg : 'video/mpeg',
  ms : 'application/x-troff-ms',
  nc : 'application/x-netcdf',
  nws : 'message/rfc822',
  o : 'application/octet-stream',
  obj : 'application/octet-stream',
  oda : 'application/oda',
  ogg : 'audio/ogg',
  ogv : 'video/ogg',
  pbm : 'image/x-portable-bitmap',
  pdf : 'application/pdf',
  pfx : 'application/x-pkcs12',
  pgm : 'image/x-portable-graymap',
  png : 'image/png',
  pnm : 'image/x-portable-anymap',
  pot : 'application/vnd.ms-powerpoint',
  ppa : 'application/vnd.ms-powerpoint',
  ppm : 'image/x-portable-pixmap',
  pps : 'application/vnd.ms-powerpoint',
  ppt : 'application/vnd.ms-powerpoint',
  pptx : 'application/vnd.ms-powerpoint',
  ps : 'application/postscript',
  pwz : 'application/vnd.ms-powerpoint',
  py : 'text/x-python',
  pyc : 'application/x-python-code',
  pyo : 'application/x-python-code',
  qt : 'video/quicktime',
  ra : 'audio/x-pn-realaudio',
  ram : 'application/x-pn-realaudio',
  ras : 'image/x-cmu-raster',
  rdf : 'application/xml',
  rgb : 'image/x-rgb',
  roff : 'application/x-troff',
  rtx : 'text/richtext',
  sgm : 'text/x-sgml',
  sgml : 'text/x-sgml',
  sh : 'application/x-sh',
  shar : 'application/x-shar',
  snd : 'audio/basic',
  so : 'application/octet-stream',
  src : 'application/x-wais-source',
  svg : 'image/svg+xml',
  swf : 'application/x-shockwave-flash',
  t : 'application/x-troff',
  tar : 'application/x-tar',
  tcl : 'application/x-tcl',
  tex : 'application/x-tex',
  texi : 'application/x-texinfo',
  texinfo : 'application/x-texinfo',
  tif : 'image/tiff',
  tiff : 'image/tiff',
  tr : 'application/x-troff',
  tsv : 'text/tab-separated-values',
  txt : 'text/plain',
  ustar : 'application/x-ustar',
  vcf : 'text/x-vcard',
  wav : 'audio/x-wav',
  webm : 'video/webm',
  wiz : 'application/msword',
  wsdl : 'application/xml',
  xbm : 'image/x-xbitmap',
  xlb : 'application/vnd.ms-excel',
  xls : 'application/vnd.ms-excel',
  xlsx : 'application/vnd.ms-excel',
  xml : 'text/xml',
  xpdl : 'application/xml',
  xpm : 'image/x-xpixmap',
  xsl : 'application/xml',
  xwd : 'image/x-xwindowdump',
  zip : 'application/zip',
  webp : 'image/webp',
  '7z': 'application/x-7z-compressed',
  opus : 'audio/ogg',
  epub : 'application/epub+zip'
};

postCommon.init = function() {

  if (!document.getElementById('fieldPostingPassword')) {
    return;
  }

  var charLimitLabel = document.getElementById('labelMessageLength');

  document.getElementById('fieldMessage').addEventListener('input',
      postCommon.updateCurrentChar);

  postCommon.currentCharLabel = document.createElement('span');

  charLimitLabel.parentNode.insertBefore(postCommon.currentCharLabel,
      charLimitLabel);

  charLimitLabel.parentNode.insertBefore(document.createTextNode('/'),
      charLimitLabel);

  postCommon.updateCurrentChar();

  postCommon.selectedCell = '<div class="removeButton">✖</div>'
      + '<span class="nameLabel"></span>'
      + '<div><label class="checkboxLabel">'
      + '<input type="checkbox" class="spoilerCheckBox">'
      + '<img class="spoilerImg" src="/spoiler.png">'
      + '</label></div>';

  postCommon.selectedFiles = [];

  postCommon.updateUploadTotal();

  if (document.getElementById('divUpload')) {
    postCommon.setDragAndDrop();
  }

  postCommon.initSpoilerFeedback();

  var savedPassword = localStorage.deletionPassword;

  if (savedPassword) {
    document.getElementById('fieldPostingPassword').value = savedPassword;

    if (document.getElementById('deletionFieldPassword')) {
      document.getElementById('deletionFieldPassword').value = savedPassword;
    }

  }

  var nameField = document.getElementById('fieldName');

  if (nameField) {
    nameField.value = localStorage.name || '';
  }

  var bypassCheckBox = document.getElementById('alwaysUseBypassCheckBox');
  bypassCheckBox.checked = false;

  // Temporary disabled
  /* if (document.cookie.indexOf("ipToken=") >= 0) {
    bypassCheckBox.checked = false;
  } else if (settings.get('ensureBypass')) {
    bypassCheckBox.checked = true;
  } else {
    bypassCheckBox.checked = false;
  } */

  var flagCombo = document.getElementById('flagCombobox');

  if (flagCombo && localStorage.savedFlags) {

    var flagInfo = JSON.parse(localStorage.savedFlags);

    if (flagInfo[api.boardUri]) {

      for (var i = 0; i < flagCombo.options.length; i++) {

        if (flagCombo.options[i].value === flagInfo[api.boardUri]) {
          flagCombo.selectedIndex = i;

          postCommon.showFlagPreview(flagCombo);

          break;
        }

      }

    }

  }

  if (flagCombo) {
    postCommon.setFlagPreviews(flagCombo);
  }

  /*
  var formMore = document.getElementById('formMore');
  formMore.classList.toggle('hidden');

  var toggled = false;

  var extra = document.getElementById('extra');
  extra.classList.toggle('hidden');

  formMore.children[0].onclick = function() {

    extra.classList.toggle('hidden');
    formMore.children[0].innerHTML = toggled ? 'More' : 'Less';

    toggled = !toggled;

    localStorage.setItem('showExtra', toggled);

  };

  if (localStorage.showExtra && JSON.parse(localStorage.showExtra)) {
    formMore.children[0].onclick();
  }
  */

};

postCommon.updateCurrentChar = function() {
  postCommon.currentCharLabel.innerHTML = document
      .getElementById('fieldMessage').value.trim().length;
};

postCommon.updateCurrentChar = function() {
  postCommon.currentCharLabel.innerHTML = document
      .getElementById('fieldMessage').value.trim().length;
};

postCommon.showFlagPreview = function(combo) {

  var index = combo.selectedIndex;

  var src;

  if (!index) {
    src = '';
  } else {
    src = '/' + api.boardUri + '/flags/' + combo.options[index].value;
  }

  var previews = document.getElementsByClassName('flagPreview');

  for (var i = 0; i < previews.length; i++) {
    previews[i].src = src;
  }

};

postCommon.setFlagPreviews = function(combo) {

  combo.addEventListener('change', function() {
    postCommon.showFlagPreview(combo);
  });

};

postCommon.savedSelectedFlag = function(selectedFlag) {

  var savedFlagData = localStorage.savedFlags ? JSON
      .parse(localStorage.savedFlags) : {};

  savedFlagData[api.boardUri] = selectedFlag;

  localStorage.setItem('savedFlags', JSON.stringify(savedFlagData));

};

postCommon.addDndCell = function(cell, removeButton) {

  if (postCommon.selectedDivQr) {
    var clonedCell = cell.cloneNode(true);
    clonedCell.getElementsByClassName('removeButton')[0].onclick = removeButton.onclick;
    postCommon.selectedDivQr.appendChild(clonedCell);

    var sourceSpoiler = cell.getElementsByClassName('spoilerCheckBox')[0];
    var destinationSpoiler = clonedCell
        .getElementsByClassName('spoilerCheckBox')[0];

    // The mirror cell's .spoiled class has to be stamped HERE, in the sync that
    // does it: a programmatic `.checked =` fires no change event, so the
    // delegated handler in initSpoilerFeedback never sees the mirrored side. Its
    // thumb hides correctly (upstream's pure-CSS :checked rule) but the
    // .spoiled-gated eye glyph would sit one state behind.
    var mirrorCell = destinationSpoiler
        ? destinationSpoiler.closest('.selectedCell') : null;

    sourceSpoiler.addEventListener('change', function() {
      if (destinationSpoiler) {
        destinationSpoiler.checked = sourceSpoiler.checked;
        if (mirrorCell) {
          mirrorCell.classList.toggle('spoiled', sourceSpoiler.checked);
        }
      }
    });

    destinationSpoiler.addEventListener('change', function() {
      sourceSpoiler.checked = destinationSpoiler.checked;
      cell.classList.toggle('spoiled', destinationSpoiler.checked);
    });

  }

  postCommon.selectedDiv.appendChild(cell);

};

// Per-file spoiler affordance (2026-10). The control itself is upstream's
// CSS-only toggle: the preview thumb is appended INSIDE the cell's <label>, so
// clicking the thumb flips the hidden .spoilerCheckBox and the
// `:checked ~ .dragAndDropThumb { display:none }` /
// `:checked ~ .spoilerImg { display:block !important }` rules
// (_boardContent.scss:216-232, Tjark 2020) swap thumb and spoiler glyph. The
// gesture has always worked on every device; what never existed is an
// affordance: the unspoiled thumb - the thing you are supposed to click -
// carries no pointer feedback, no label, and on touch there is no tooltip to
// carry one. The three additions below are all out of flow: the post card is
// shrink-wrapped to its widest row, so no element here may add width or height.
// Thumbless cells are deliberately excluded: their label holds only hidden
// elements, so they have no tappable area and cannot be spoiled individually.
postCommon.SPOILER_HINT_KEY = 'spoilerHintSeen';

// One-shot caption over the attachment row: shown the first time a preview
// thumb appears for this user, removed on their first spoiler toggle (or after
// 4s). Absolutely positioned in CSS, so it is not a flex item of #selectedDiv
// and cannot grow the row.
postCommon.showSpoilerHintOnce = function(container) {

  if (!container || localStorage.getItem(postCommon.SPOILER_HINT_KEY)) {
    return;
  }

  localStorage.setItem(postCommon.SPOILER_HINT_KEY, '1');

  var hint = document.createElement('div');
  hint.className = 'spoilerHint';
  hint.textContent = lang.spoilerHint;
  container.appendChild(hint);

  var dismiss = function() {
    clearTimeout(timer);
    document.removeEventListener('change', onToggle, true);
    if (hint.parentNode) {
      hint.parentNode.removeChild(hint);
    }
  };

  var onToggle = function(event) {
    if (event.target && event.target.classList
        && event.target.classList.contains('spoilerCheckBox')) {
      dismiss();
    }
  };

  var timer = setTimeout(dismiss, 4000);

  document.addEventListener('change', onToggle, true);

};

// State caption inside the cell after each toggle, so a first accidental tap
// reads as "spoiled - click to reveal" instead of a vanished thumbnail.
// Delegated on purpose: the quick-reply panel mirrors every cell with
// cloneNode, and a clone carries hasPreview without any listener of its own,
// so a delegated change handler covers both forms with no extra wiring.
postCommon.initSpoilerFeedback = function() {

  if (postCommon.spoilerFeedbackInit) {
    return;
  }

  postCommon.spoilerFeedbackInit = true;

  document.addEventListener('change', function(event) {

    var box = event.target;

    if (!box || !box.classList
        || !box.classList.contains('spoilerCheckBox')) {
      return;
    }

    var cell = box.closest('.selectedCell');

    if (!cell || !cell.classList.contains('hasPreview')) {
      return;
    }

    // The spoiled state goes on the CELL, not just into the checkbox. The
    // affordance mark lives on the label (the parent), and CSS cannot read a
    // descendant checkbox's :checked state without :has() - which old Safari on
    // iOS does not have. A class the delegated handler maintains works
    // everywhere, covers QR clones for free, and gives themes a real hook.
    cell.classList.toggle('spoiled', box.checked);

    var old = cell.getElementsByClassName('spoilerState')[0];

    if (old) {
      cell.removeChild(old);
    }

    var tip = document.createElement('div');
    tip.className = 'spoilerState' + (box.checked ? ' spoiled' : '');
    tip.textContent = box.checked ? lang.spoilerOn : lang.spoilerOff;
    cell.appendChild(tip);

    setTimeout(function() {
      if (tip.parentNode) {
        tip.parentNode.removeChild(tip);
      }
    }, 1800);

  });

};

// Section: Upload size budget {
//
// WHY THIS EXISTS. nginx enforces client_max_body_size 10m on BOTH boxes
// (kohlproxy edge + the app VM) and it measures the WHOLE multipart body:
// file bytes + every form field + each part's boundary and headers. An
// over-budget body is killed at nginx — a stock 413 HTML page comes back and
// the engine is never reached — and api.formApiRequest renders EVERY non-200
// as a bare "Connection failed." dialog. So an over-size post looks exactly
// like a network outage to the user, with no size hint anywhere.
//
// Nothing else in the stack knows about the total. The engine's checkFile()
// is PER FILE (maxFileSizeMB) and maxFiles is a count, so the posting form
// advertises "10 MB max · 6 files" (= up to 60 MB of files) while the
// transport caps a single request at 10 MB.
//
// 10MB is hardcoded on operator ruling (2026-10): that limit has stood for
// years on both boxes and is not expected to move. IF nginx's
// client_max_body_size EVER CHANGES, THIS NUMBER HAS TO CHANGE WITH IT.
postCommon.maxRequestSizeB = 10 * 1024 * 1024;

// Per-part cost of the multipart encoding. 9 plain fields ride in every post
// (boardUri, message, subject, password, name, noFlag, spoiler, sage,
// captcha) and each attachment adds 4 metadata fields + 1 file part, every
// one carrying its own boundary + Content-Disposition + Content-Type.
// ~150 bytes each, rounded up.
postCommon.multipartOverheadPerPartB = 150;
postCommon.multipartPlainFields = 9;

// UTF-8 byte length of a string — the multipart body is byte-counted, and a
// non-ASCII post (Cyrillic, emoji) is 2-4 bytes per character.
postCommon.uploadByteLength = function(str) {

  if (!str) {
    return 0;
  }

  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(str).length;
  }

  return unescape(encodeURIComponent(str)).length;

};

postCommon.uploadFieldValue = function(id) {

  var field = document.getElementById(id);

  return field ? field.value : '';

};

// Text + form bytes that ride along in the SAME request body as the files.
// Both the main posting form and the quick reply are probed and summed, so a
// page carrying both (a thread page) over-counts slightly. Over-counting is
// the safe direction: it blocks a hair early instead of shipping a 413.
postCommon.uploadTextSizeB = function() {

  return postCommon.uploadByteLength(
      postCommon.uploadFieldValue('fieldMessage')
      + postCommon.uploadFieldValue('fieldSubject')
      + postCommon.uploadFieldValue('fieldName')
      + postCommon.uploadFieldValue('fieldPostingPassword')
      + postCommon.uploadFieldValue('qrbody')
      + postCommon.uploadFieldValue('qrsubject')
      + postCommon.uploadFieldValue('qrname')
      + postCommon.uploadFieldValue('qrpassword'));

};

postCommon.formatUploadBytes = function(bytes) {

  var orders = [ 'B', 'KB', 'MB', 'GB' ];
  var orderIndex = 0;
  var value = bytes;

  while (orderIndex < orders.length - 1 && value > 1024) {
    orderIndex++;
    value /= 1024;
  }

  return (orderIndex === 0 ? value.toFixed(0) : value.toFixed(2)) + ' '
      + orders[orderIndex];

};

// 2-decimal MB, FIXED digit count: the readout overwrites the engine's
// "10 MB" label in place, so a variable-width number would resize the row.
// Only the SUM gets decimals - the cap is a constant and reads as "10 MB",
// so the label spends its fixed width on the number that changes
// (operator 2026-10). Paired with tabular-nums + min-width in _posting.scss.
postCommon.formatBudgetMB = function(bytes) {

  return (bytes / (1024 * 1024)).toFixed(2);

};

// Advisory number shown live as files are attached. It is the NAIVE sum: the
// per-file existence checks have not run yet, so re-attaching a file the site
// already stores shows at full size here even though its bytes would not be
// uploaded. That is the conservative direction, so gating on it can never let
// an over-budget request through.
postCommon.getSelectedFilesSizeB = function() {

  var total = 0;

  for (var i = 0; i < postCommon.selectedFiles.length; i++) {
    total += postCommon.selectedFiles[i].size;
  }

  return total;

};

// Total bytes a post with the CURRENT files + text would put on the wire.
postCommon.uploadRequestBodySizeB = function() {

  var parts = postCommon.multipartPlainFields
      + postCommon.selectedFiles.length * 5;

  return postCommon.getSelectedFilesSizeB()
      + postCommon.uploadTextSizeB()
      + parts * postCommon.multipartOverheadPerPartB;

};

// The readout overwrites the engine-filled size label IN PLACE (main form
// #labelMaxFileSize, quick reply #qrLabelMaxFileSize) — no extra element, so
// the shrink-wrapped post card never grows. The engine writes the PER-FILE max
// here at page-generation time; every board runs at the global 10MB today, so
// the two numbers coincide. Always visible (0.00 baseline), fixed-width, so
// attaching/removing files cannot shift the form.
postCommon.updateUploadTotal = function() {

  var filesB = postCommon.getSelectedFilesSizeB();

  var text = postCommon.formatBudgetMB(filesB) + '/'
      + Math.round(postCommon.maxRequestSizeB / (1024 * 1024)) + ' MB';

  var over = postCommon.uploadRequestBodySizeB() > postCommon.maxRequestSizeB;

  var ids = [ 'labelMaxFileSize', 'qrLabelMaxFileSize' ];

  for (var k = 0; k < ids.length; k++) {

    var el = document.getElementById(ids[k]);

    if (!el) {
      continue;
    }

    el.textContent = text;

    if (over) {
      el.classList.add('redText');
    } else {
      el.classList.remove('redText');
    }

  }

};

// PRE-FLIGHT, run at the top of the Post/Reply click, BEFORE blockBypass and
// BEFORE solveCaptcha. Position matters: the captcha is consumed
// server-side by solveCaptcha, so a gate placed any later burns the user's
// solved captcha, leaves the same image on screen, and their next attempt
// reads "wrong answer or expired captcha". Nothing is spent here: no captcha,
// no sha256, no per-file existence round-trips, and the submit buttons are
// not disabled yet at this point, so an abort needs no button-restore path.
// Returns true when the caller must NOT proceed.
postCommon.blockOverBudgetPost = function() {

  // Upload-less pages (text boards, flags) have no budget to check.
  if (!document.getElementById('divUpload')) {
    return false;
  }

  var totalB = postCommon.uploadRequestBodySizeB();

  if (totalB <= postCommon.maxRequestSizeB) {
    return false;
  }

  api.alert(lang.uploadTooLarge.replace('__total__',
      postCommon.formatUploadBytes(totalB)).replace('__limit__',
      postCommon.formatUploadBytes(postCommon.maxRequestSizeB)));

  postCommon.updateUploadTotal();

  return true;

};
// } Section: Upload size budget

postCommon.addSelectedFile = function(file, previewDataUrl) {

  previewDataUrl = previewDataUrl || null; // custom argument

  var cell = document.createElement('div');
  cell.className = 'selectedCell';

  cell.innerHTML = postCommon.selectedCell;

  var nameLabel = cell.getElementsByClassName('nameLabel')[0];
  nameLabel.textContent = file.name;

  var removeButton = cell.getElementsByClassName('removeButton')[0];

  removeButton.onclick = function() {
    var index = postCommon.selectedFiles.indexOf(file);

    if (postCommon.selectedDivQr) {

      for (var i = 0; i < postCommon.selectedDiv.childNodes.length; i++) {
        if (postCommon.selectedDiv.childNodes[i] === cell) {
          postCommon.selectedDivQr
              .removeChild(postCommon.selectedDivQr.childNodes[i]);
        }
      }

    }

    postCommon.selectedDiv.removeChild(cell);

    postCommon.selectedFiles.splice(postCommon.selectedFiles.indexOf(file), 1);

    postCommon.updateUploadTotal();
  };

  postCommon.selectedFiles.push(file);

  postCommon.updateUploadTotal();

  if (!file.type.indexOf('image/')) {

    var addPreviewDndCell = function(dataUrl) {
      var checkboxLabel = cell.getElementsByClassName('checkboxLabel')[0]
      var checkbox = cell.getElementsByClassName('spoilerCheckBox')[0]

      var dndThumb = document.createElement('img');
      dndThumb.src = dataUrl;
      dndThumb.className = 'dragAndDropThumb';
      checkboxLabel.appendChild(dndThumb);
      cell.classList.add('hasPreview');

      postCommon.addDndCell(cell, removeButton);

      postCommon.showSpoilerHintOnce(postCommon.selectedDiv);
    }

    if (previewDataUrl) {
      addPreviewDndCell(previewDataUrl);
    } else {
      postCommon.fileToDataUrl(file, addPreviewDndCell);
    }

  } else {
    postCommon.addDndCell(cell, removeButton);
  }

};

postCommon.clearSelectedFiles = function() {

  if (!document.getElementById('divUpload')) {
    return;
  }

  postCommon.selectedFiles = [];

  postCommon.updateUploadTotal();

  while (postCommon.selectedDiv.firstChild) {
    postCommon.selectedDiv.removeChild(postCommon.selectedDiv.firstChild);
  }

  if (postCommon.selectedDivQr) {
    while (postCommon.selectedDivQr.firstChild) {
      postCommon.selectedDivQr.removeChild(postCommon.selectedDivQr.firstChild);
    }
  }

};

postCommon.setDragAndDrop = function(qr) {

  var fileInput = document.getElementById('inputFiles');

  if (!qr) {
    fileInput.style.display = 'none';
    document.getElementById('dragAndDropDiv').style.display = 'block';

    /* BEGIN Workaround from endchan */

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (iOS) {
      console.log('iOS detected, enabling workaround')
      // iOS Safari fires `change` unreliably for file picks (esp. from
      // Photos/camera), so poll the FileList instead. Two things to get right:
      //  - a fresh picker pick REPLACES the FileList, so a length count can't
      //    tell "new pick" from "the same batch I already added" — it drops
      //    every sequential single pick;
      //  - the remove button only splices selectedFiles + the DOM cell, it
      //    never clears fileInput.files, so checking against selectedFiles
      //    resurrects a removed file on the next tick.
      // Track File references we have already seen (independent of
      // selectedFiles): add a file only if never seen before. New picks are
      // new objects -> added; removed-but-still-in-input files stay seen ->
      // not re-added.
      // ONE poller, always: the handle and the seen-list live on postCommon,
      // and any previous interval is cleared before re-arming, so this block
      // can never stack pollers (stacked intervals = every new pick added
      // once per poller). Prevention, not a live bug: the only caller that
      // reaches this block is the main-form call (the QR call passes qr=true
      // and skips it, as in the upstream original), and init() runs once per
      // page, so today there is exactly one interval per page. Verified
      // 2026-10: the iOS double-add was never observed on any device; the
      // OPEN.md mechanism ("QR adds a second interval") did not survive a
      // source check against every version back to upstream.
      if (postCommon.iosPoll) {
        clearInterval(postCommon.iosPoll);
      }
      // The seen-list is initialized ONCE and survives re-arms: clearing it on
      // re-arm would re-add files still sitting in fileInput.files (the
      // resurrection bug fixed in 509bd004). New picks are new File objects,
      // so they land in the list and get added exactly once.
      if (!postCommon.iosSeenFiles) {
        postCommon.iosSeenFiles = [];
      }
      postCommon.iosPoll = setInterval(function() {
        for (var i = 0; i < fileInput.files.length; i++) {
          var f = fileInput.files[i];
          if (postCommon.iosSeenFiles.indexOf(f) === -1) {
            postCommon.iosSeenFiles.push(f);
            console.log('detected new file')
            postCommon.addSelectedFile(f);
          }
        }
      }, 1000)
    } else {

      fileInput.onchange = function() {

        for (var i = 0; i < fileInput.files.length; i++) {
          postCommon.addSelectedFile(fileInput.files[i]);
        }

        fileInput.type = "text";
        fileInput.type = "file";
      };
    }

    /* END Workaround from endchan */

  }

  var drop = document.getElementById(qr ? 'dropzoneQr' : 'dropzone');
  drop.onclick = function() {
    fileInput.click();
  };

  if (!qr) {
    postCommon.selectedDiv = document.getElementById('selectedDiv');
    document.addEventListener('paste', function handleFileSelect(evt) {
      //evt.stopPropagation();
      //evt.preventDefault();

      var clipboard = evt.clipboardData;
      if (!clipboard.items || !clipboard.items.length)
        return;

      for (var i=0; i<clipboard.items.length; i++) {
        var cbItem = clipboard.items[i];

        if (cbItem.kind !== 'file' || cbItem.type.indexOf('image/') !== 0)
          continue;

        var file = cbItem.getAsFile();
        var timestamp = Math.round(new Date()/1000);
        var fileName = lang.clipboardImage + '-' + timestamp;

        var addFile = function(file, type, format, previewDataUrl) {
          var fileObj = new File([file], fileName + '.' + format, {type: type});
          postCommon.addSelectedFile(fileObj, previewDataUrl);
        };

        if (settings.get('compressClipboardImages')) {
          postCommon.compressImage(file, addFile);
        } else {
          addFile(file, 'image/png', 'png');
        }
      }

    }, false);

  } else {
    postCommon.selectedDivQr = document.getElementById('selectedDivQr');
  }

  drop.addEventListener('dragover', function handleDragOver(event) {

    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';

  }, false);

  drop.addEventListener('drop', function handleFileSelect(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    for (var i = 0; i < evt.dataTransfer.files.length; i++) {
      postCommon.addSelectedFile(evt.dataTransfer.files[i])
    }

  }, false);

};

postCommon.getMime = function(pathName) {

  var pathParts = pathName.split('.');

  var mime;

  if (pathParts.length) {
    mime = postCommon.MIMETYPES[pathParts[pathParts.length - 1].toLowerCase()];
  }

  return mime || 'application/octet-stream';
};

// Hashes the file and asks the server whether it already has these bytes, so a
// file the board stores is never uploaded twice: media is sha-addressed
// (uploadHandler.processFile writes at /.media/<sha> and keeps a references
// counter), so declaring the hash is enough for a post to reference the file.
// Unconditional since 2026-10 - the setting that gated it only ever added cost (a
// re-uploaded known file is hashed by the engine and then discarded, never stored
// twice) and its OFF state was the path that left the metadata below undeclared.
// The hash is ALWAYS computed and ALWAYS passed to the callback, including on the
// failure path, because the callback's sha256 is what makes api.formApiRequest emit
// the file's metadata group (it appends fileSha256/fileMime/fileSpoiler/fileName as
// one unit, gated on sha256 being set). A file that ships bytes without a
// metadata entry cannot be joined server-side - formOps.getNewFiles walks the
// metadata list, so its bytes are uploaded, hashed by the engine, and silently
// discarded, and the post lands with one file fewer and no message. 'found'
// false on a failed lookup is the honest answer: we do not know, so send bytes.
postCommon.newCheckExistance = function(file, callback) {

  var reader = new FileReader();

  reader.onloadend = async function() {


    if (reader.result == null) {
      // The read failed - the file was moved/renamed/deleted after it was
      // attached, or an iOS/Android content URI expired. No bytes, so no hash:
      // signal that by calling back empty and let the caller drop this file
      // LOUDLY. Passing a hash here is impossible, and an empty callback is
      // safe now that the caller handles it.
      callback();
      return;
    }

    // The browser's own type guess is empty for many extensions, and the engine
    // skips a metadata entry whose mime is empty (formOps.getMetaData: `if
    // (!sha256[i] || !mime[i] || !name[i]) continue;`) - which drops the entry
    // and takes the whole file with it, the same silent loss as a missing hash.
    // Fall back to the extension table; 'application/octet-stream' is the
    // fallback of getMime and is a valid declared value, and the engine replaces
    // the guess with the real detected mime (applyRealMimes) anyway.
    var declaredMime = file.type || postCommon.getMime(file.name);

    if (crypto.subtle) {

      var hashBuffer = await
      crypto.subtle.digest('SHA-256', reader.result);

      var hashArray = Array.from(new Uint8Array(hashBuffer));

      var hashHex = hashArray.map(function(b) {
        return b.toString(16).padStart(2, '0');
      }).join('');

    } else {

      var i8a = new Uint8Array(reader.result);
      var a = [];

      for (var i = 0; i < i8a.length; i += 4) {
        a.push(i8a[i] << 24 | i8a[i + 1] << 16 | i8a[i + 2] << 8 | i8a[i + 3]);
      }

      var wordArray = CryptoJS.lib.WordArray.create(a, i8a.length);
      var hashHex = CryptoJS.SHA256(wordArray).toString();
    }

    api.formApiRequest('checkFileIdentifier', {}, function requested(status,
        data) {

      if (status !== 'ok') {
        console.log(data);
        callback(hashHex, declaredMime, false);
      } else {
        callback(hashHex, declaredMime, data);
      }

    }, false, {
      identifier : hashHex
    });

  };

  reader.readAsArrayBuffer(file);

};

postCommon.newGetFilesToUpload = function(callback, index, files) {

  index = index || 0;
  files = files || [];

  if (!document.getElementById('divUpload')
      || index >= postCommon.selectedFiles.length) {
    callback(files);
    return;
  }

  var spoiled = postCommon.selectedDiv
      .getElementsByClassName('spoilerCheckBox')[index].checked;

  var file = postCommon.selectedFiles[index];

  postCommon.newCheckExistance(file, function checked(sha256, mime, found) {

    if (!sha256) {
      // Unreadable file (see newCheckExistance). It cannot be hashed and its
      // bytes cannot be sent, so it cannot take part in this post. Say so and
      // move on with the remaining files: a file that cannot be read used to
      // stall the whole submission here, because this recursion only continues
      // inside this callback and the callback was never called at all.
      api.alert(lang.cannotReadFile.replace('__file__', file.name));
      postCommon.newGetFilesToUpload(callback, ++index, files);
      return;
    }

    var toPush = {
      name : postCommon.selectedFiles[index].name,
      spoiler : spoiled,
      sha256 : sha256,
      mime : mime
    };

    if (!found) {
      toPush.content = file;
    }

    files.push(toPush);

    postCommon.newGetFilesToUpload(callback, ++index, files);

  });

};

postCommon.displayBlockBypassPrompt = function(callback) {

  var outerPanel = captchaModal
      .getCaptchaModal(lang.youNeedBlockBypass);

  var okButton = outerPanel.getElementsByClassName('modalOkButton')[0];

  okButton.onclick = function() {

    var typedCaptcha = outerPanel.getElementsByClassName('modalAnswer')[0].value
        .trim();

    if (/\W/.test(typedCaptcha)) {
      alert('Invalid captcha.');
      return;
    }

    api.formApiRequest('renewBypass', {
      captcha : typedCaptcha
    }, function requestComplete(status, data) {

      if (status === 'ok') {

        if (callback) {
          callback();
        }

        outerPanel.remove();

      } else if (status === 'hashcash') {

        /*
         * FAST PASS (2026-10-20) — the whole mint runs HERE, in this modal.
         * The old shape handed the user a target='_blank' link to the kohlcash
         * page, left this modal open with "Almost there!" and no way to learn the
         * mint had finished (the page version is a separate tab; there is no
         * postMessage/storage event), then the solved state was a third page asking
         * them to save a link. Operator ruling: unshippable. The mint is the same
         * engine on the same two endpoints (see fastpass.js); the modal closes on
         * success and the post resumes.
         */
        okButton.remove();

        document.getElementsByClassName('modalHeader')[0].innerHTML = lang.fastpassTitle;
        document.getElementsByClassName('captchaImageContainer')[0].remove();
        document.getElementsByClassName('modalCaptchaTable')[0].remove();

        var cancelButton = document.getElementsByClassName('cancelButton')[0];
        cancelButton.value = lang.closeButton;

        var innerPanel = document.getElementsByClassName('modalInnerDecorationPanel')[0];

        // Cost is disclosed BEFORE the CPU work starts, never after.
        var costText = document.createElement('p');
        costText.className = 'fastpassText';
        costText.innerHTML = lang.fastpassCost;
        innerPanel.insertBefore(costText, cancelButton);

        var progress = document.createElement('progress');
        progress.className = 'fastpassProgress';
        progress.max = 100;
        progress.value = 0;
        innerPanel.insertBefore(progress, cancelButton);

        var statusText = document.createElement('p');
        statusText.className = 'fastpassText';
        statusText.innerHTML = lang.fastpassWorking;
        innerPanel.insertBefore(statusText, cancelButton);

        var closeAndProceed = function() {

          fastpass.stop();
          outerPanel.remove();

          if (callback) {
            callback();
          }

        };

        var fallbackLink = function() {

          // Only the browsers that cannot run Worker+WebAssembly land here, which
          // is exactly the case kohlcash's own page + external solver exist for.
          var p = document.createElement('p');
          p.className = 'fastpassText';
          p.innerHTML = "<a target='_blank' href='/addon.js/hashcash/?action=get'>"
              + lang.hashcashInfo + "</a>";
          innerPanel.insertBefore(p, cancelButton);

        };

        fastpass.mint({

          onText: function(text) {
            statusText.innerHTML = text;
          },

          onProgress: function(percentage) {
            progress.value = percentage;
            statusText.innerHTML = lang.fastpassWorking + ' ' +
                percentage.toFixed(0) + '%';
          },

          onDone: function() {
            statusText.innerHTML = lang.fastpassDone;
            progress.value = 100;
            closeAndProceed();
          },

          onFail: function(status) {
            statusText.innerHTML = lang.fastpassFail;
            fallbackLink();
            // BUTTONDISABLE — leave the reply controls usable, as cancel does.
            if (typeof thread !== 'undefined' &&
                typeof thread.replyButton !== 'undefined') {
              thread.replyButton.disabled = false;
              qr.setQRReplyEnabled(true);
            }
          }

        });

      } else if (status === 'finish') {

        if (callback) {
          callback();
        }

        outerPanel.remove();

      } else {

        alert(status + ': ' + JSON.stringify(data));

      }
    });

  };

};

postCommon.storeUsedPostingPassword = function(boardUri, threadId, postId) {

  var storedData = JSON.parse(localStorage.postingPasswords || '{}');

  var key = boardUri + '/' + threadId

  if (postId) {
    key += '/' + postId;
  }

  storedData[key] = localStorage.deletionPassword;

  localStorage.setItem('postingPasswords', JSON.stringify(storedData));

};

postCommon.compressImage = function(imageBlob, callback) {

  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var img = new Image();

  var useWebp = postCommon.webpSupported();
  var targetQuality = 1; // imageBlob.size > 4 * 1024 * 1024 ? 0.95 : 1;
  var targetFileType = useWebp ? 'image/webp' : 'image/jpeg';
  var targetFormat = useWebp ? 'webp' : 'jpeg';

  postCommon.fileToDataUrl(imageBlob, function(dataUrl) {

    img.onload = function() {
      canvas.width = this.width;
      canvas.height = this.height;

      ctx.drawImage(img, 0, 0);

      canvas.toBlob(function(blob) {
        callback(blob, targetFileType, targetFormat, dataUrl);
      }, targetFileType, targetQuality);
    };

    img.onerror = function() {
      callback(imageBlob, 'image/png', 'png', dataUrl);
    };

    img.src = dataUrl;

  });

};

postCommon.fileToDataUrl = function(file, callback) {

  var fileReader = new FileReader();

  fileReader.onloadend = function() {
    callback(fileReader.result);
  };

  fileReader.readAsDataURL(file);

}

postCommon.webpSupported = function() {

  // firefox has very poor realisation of webp
  var minSupportedChromium = 60;
  var ver = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

  return ver ? parseInt(ver[2]) > minSupportedChromium : false;

};

postCommon.init();
